export function setFlowScale(
  element: SVGElement | null,
  pxPerImagePx: number
): void {
  if (!element) return
  const unit =
    Number.isFinite(pxPerImagePx) && pxPerImagePx > 0 ? 1 / pxPerImagePx : 1
  const property = '--flow-image-unit'
  const previous = Number.parseFloat(element.style.getPropertyValue(property))
  if (previous > 0 && Math.abs(unit / previous - 1) < 0.1) return
  element.style.setProperty(property, `${unit}px`)
  element.style.setProperty('--flow-image-scale', String(unit))
}
